import React, { useState, useEffect } from "react";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";
import { Input as BaseInput, InputProps, inputClasses } from "@mui/base/Input";

import { FaPhone } from "react-icons/fa6";
import { MdEmail } from "react-icons/md";
import { FaRobot } from "react-icons/fa6";
import { FaVideo } from "react-icons/fa6";
import { BiLogoMicrosoftTeams } from "react-icons/bi";
import { BsTwitterX } from "react-icons/bs";
import { IoLogoWhatsapp } from "react-icons/io";
import { FaFacebookF } from "react-icons/fa";
import { IoChatbubbles } from "react-icons/io5";

import {
  Stack,
  TableRow,
  TableHead,
  TableContainer,
  TableBody,
  Table,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Button,
  DialogActions,
  Slide,
  Box,
} from "@mui/material";
import { Eye, MagnifyingGlass } from "@phosphor-icons/react";
import { BaseUrl, emailservice } from "../../Container/BaseUrl/BaseUrl";
import axios from "axios";
import moment from "moment";
import {
  AudioMsg,
  DocMsg,
  ImageMsg,
  TextMsg,
  Timeline,
  VideoMsg,
} from "../../Components/chat-components/Chat-component/MessageTypes-component/MsgTypes";
import EmailBody from "../../Components/chat-components/Chat-component/EmailBodyComponent/EmailBody";

const Input = React.forwardRef(function CustomInput(props, ref) {
  const { slots, ...other } = props;

  return (
    <BaseInput
      slots={{
        root: InputRoot,
        input: InputElement,
        ...slots,
      }}
      {...other}
      ref={ref}
    />
  );
});

const blue = {
  100: "#DAECFF",
  200: "#80BFFF",
  400: "#3399FF",
  500: "#007FFF",
  600: "#0072E5",
  700: "#0059B2",
};

const grey = {
  50: "#F3F6F9",
  100: "#E5EAF2",
  200: "#DAE2ED",
  300: "#C7D0DD",
  400: "#B0B8C4",
  500: "#9DA8B7",
  600: "#6B7A90",
  700: "#434D5B",
  800: "#303740",
  900: "#1C2025",
};

const InputRoot = styled("div")(
  ({ theme }) => `
  font-family: 'IBM Plex Sans', sans-serif;
  font-weight: 400;
  border-radius: 8px;
  color: ${theme.palette.mode === "dark" ? grey[300] : grey[500]};
  background: ${theme.palette.mode === "dark" ? grey[900] : "#fff"};
  border: 1px solid ${theme.palette.mode === "dark" ? grey[700] : grey[200]};
  box-shadow: 0px 2px 4px ${theme.palette.mode === "dark" ? "rgba(0,0,0, 0.5)" : "rgba(0,0,0, 0.05)"
    };
  display: flex;
  align-items: center;
  justify-content: center;


  // firefox
  &:focus-visible {
    outline: 0;
  }
`
);

const InputElement = styled("input")(
  ({ theme }) => `
  font-size: 0.875rem;
  font-family: inherit;
  font-weight: 400;
  line-height: 1.5;
  flex-grow: 1;
  color: ${theme.palette.mode === "dark" ? grey[300] : grey[900]};
  background: inherit;
  border: none;
  border-radius: inherit;
  padding: 8px 12px;
  outline: 0;
  width: 450px;
 
  &:focus-visible {
    outline:none;
    outline-offset: none;
  }
  
`
);

const InputAdornment = styled("div")`
  margin: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#e9e9e9",
    color: theme.palette.common.black,
    padding: "10px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: "13px",
  },
}));

const StyledTableCell2 = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.root}`]: {
    backgroundColor: "#FFFF",
    color: theme.palette.common.black,
    padding: "7px 10px",
    fontSize: "13px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: "12px",
  },
}));

const SessionHistory = (props) => {
  const logedinAgent = JSON.parse(localStorage.getItem("tokenAgent"));
  const [sessionVal, setsessionVal] = useState([]);
  const [SummeryOpenDialog, setSummeryOpenDialog] = useState(false);
  const [ChatHistoryOpenDialog, setChatHistoryOpenDialog] = useState(false);
  const [ChatHistory, setChatHistory] = useState([]);
  const [Sessionvalforemail, setSessionvalforemail] = useState([]);
  const [SummeryData, setSummeryData] = useState();
  const [SummeryData2, setSummeryData2] = useState();

  const [searchMessage, setsearchMessage] = useState("");
  var someDate = new Date();
  var date = someDate.setDate(someDate.getDate());
  var defaultValue = new Date(date).toISOString().split("T")[0];

  const [expanded, setExpanded] = useState();
  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const getSessionsDetails = async (value) => {
    await axios
      .post(
        BaseUrl + "/message/getSessions/",
        {
          email: props.selectedUser.email,
          phonenumber: props.selectedUser.phonenumber,
          date: value,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.success) {
          setsessionVal(res.data.data);
        } else {
          setsessionVal([]);
        }
      });
  };

  const handleShowDetails = async (session_id) => {
    await axios
      .post(
        BaseUrl + "/message/getSummery/",
        { sessionId: session_id },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.success) {
          setSummeryData(res.data.data[0]);
          setSummeryData2(res.data.data[1]);
          setSummeryOpenDialog(true);
        } else {
          setSummeryData();
          setSummeryData2();
          setSummeryOpenDialog(true);
        }
      })
      .catch((err) => { });
  };

  const showChatHistoryDialogBox = async (value) => {
    await axios
      .post(
        BaseUrl + "/message/chatHistories/",
        { sessionId: value },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          setChatHistory(res.data.data);
          setChatHistoryOpenDialog(true);
        } else {
          setChatHistory([]);
          setChatHistoryOpenDialog(true);
        }
      })
      .catch((err) => {
        console.log("err", err);
        setChatHistory([]);
        setChatHistoryOpenDialog(true);
      });
  };

  const getSessionsDetailsForEmail = async (value, value2) => {
    const access_token = localStorage.getItem("access_token");
    const tenantId = localStorage.getItem("TenantId");

    await axios
      .post(
        emailservice + "/fetchEmailSummary",
        {
          sessionId: value,
          ticketID: value2,
        },
        {
          headers: {
            Authorization: "Bearer " + access_token,
            "Content-Type": "application/json",
            tenantId: tenantId,
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          setSessionvalforemail(res.data.Data);
          setChatHistoryOpenDialog(true);
        } else {
          setChatHistoryOpenDialog(false);
          setSessionvalforemail([]);
        }
      });
  };

  useEffect(() => {
    getSessionsDetails(defaultValue);
  }, [props.selectedUser]);

  const SummeryCloseDialogBox = () => {
    setSummeryOpenDialog(false);
  };
  const ChatHistoryCloseDialog = () => {
    setChatHistoryOpenDialog(false);
    setSummeryOpenDialog(true);
  };

  return (
    <>
      <div
        className="tab-pane fade show active"
        id="pills-profile"
        role="tabpanel"
        aria-labelledby="pills-profile-tab"
      >
        <TableContainer sx={{ height: "100%", width: "100%", fontSize: "13px" }}>
          <Table stickyHeader aria-label="sticky table" className="fs-13">
            <TableHead className="fs-13">
              <TableRow>
                <StyledTableCell>Channel</StyledTableCell>
                <StyledTableCell>Agent</StyledTableCell>
                <StyledTableCell>Language</StyledTableCell>
                <StyledTableCell>Date</StyledTableCell>
                <StyledTableCell>SkillSet</StyledTableCell>
                <StyledTableCell>Reason</StyledTableCell>
                <StyledTableCell>Action</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {sessionVal.length > 0
                ? sessionVal.map((item) => (
                  <TableRow hover role="checkbox" tabIndex={-1}>
                    <StyledTableCell2 align="center">
                      {item.channel == "webchat" ? (
                        <div className="box d-flex align-items-center justify-content-center sms-bg">
                          <IoChatbubbles size={18} />
                        </div>
                      ) : item.channel == "from_whatsapp" ? (
                        <div className="box d-flex align-items-center justify-content-center what-bg">
                          <IoLogoWhatsapp size={15} />
                        </div>
                      ) : item.channel == "from_facebook" ? (
                        <div className="box d-flex align-items-center justify-content-center fb-bg">
                          <FaFacebookF size={14} />
                        </div>
                      ) : item.channel == "from_twitter" ? (
                        <div className="box d-flex align-items-center justify-content-center twit-bg">
                          <BsTwitterX size={14} />
                        </div>
                      ) : item.channel == "from_teams" ? (
                        <div className="  box d-flex align-items-center justify-content-center teams-bg">
                          <BiLogoMicrosoftTeams />
                        </div>
                      ) : item.channel == "videochat" ? (
                        <div className="box d-flex align-items-center justify-content-center twit-bg">
                          <FaVideo size={18} />
                        </div>
                      ) : item.channel == "voice" ? (
                        <div
                          className="box d-flex align-items-center justify-content-center  call-bg" >
                          <FaPhone size={13} />
                        </div>
                      ) : item.channel == "from_purple" ? (
                        <div className="box d-flex align-items-center justify-content-center twit-bg">
                          <FaRobot size={15} />
                        </div>
                      ) : (
                        <div className="  box d-flex  align-items-center justify-content-center twit-bg">
                          <MdEmail size={18} />
                        </div>
                      )}
                    </StyledTableCell2>
                    <StyledTableCell2 style={{ width: "max-content" }}>
                      {item.agent?.username}
                    </StyledTableCell2>
                    <StyledTableCell2>{item.language}</StyledTableCell2>
                    <StyledTableCell2>
                      {moment(item.chat_started_at).format("L LT")}
                    </StyledTableCell2>
                    <StyledTableCell2>{item.skillset}</StyledTableCell2>
                    <StyledTableCell2>{item.reason}</StyledTableCell2>
                    <StyledTableCell2>
                      {item.channel == "voice" ? null : (
                        <IconButton
                          id="view_summery"
                          onClick={() => {
                            setSummeryOpenDialog(true);
                            handleShowDetails(item.chat_session_id);
                          }}
                        >
                          <Eye size={18} cursor={"pointer"} />
                        </IconButton>
                      )}
                    </StyledTableCell2>
                  </TableRow>
                ))
                : ""}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      {/* SUMMARY DIALOG */}
      {SummeryOpenDialog && (
        <Dialog
          open={SummeryOpenDialog}
          keepMounted
          onClose={SummeryCloseDialogBox}
          aria-describedby="alert-dialog-slide-description"
          fullWidth maxWidth="lg"
        >
          <DialogTitle
            variant="subtitle2"
            sx={{ fontSize: "16px", fontWeight: 600, color: "#0b3363", boxShadow: "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px" }}
          >
            Summary
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              <Box className="mt-3">
                <TableContainer >
                  <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                      <TableRow>
                        <StyledTableCell>Chat Arrival At</StyledTableCell>
                        <StyledTableCell>Chat Started At</StyledTableCell>
                        <StyledTableCell>Comments</StyledTableCell>
                        <StyledTableCell>Chat End At</StyledTableCell>
                        <StyledTableCell>Channel</StyledTableCell>
                        <StyledTableCell>SkillSet</StyledTableCell>
                        <StyledTableCell>Agent</StyledTableCell>
                        <StyledTableCell>View</StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow hover role="checkbox" tabIndex={-1}>
                        <StyledTableCell2>
                          {SummeryData
                            ? moment(SummeryData.arrival_at).format("L LT")
                            : ""}
                        </StyledTableCell2>
                        <StyledTableCell2>
                          {SummeryData
                            ? moment(SummeryData.chat_started_at).format("L LT")
                            : ""}
                        </StyledTableCell2>
                        <StyledTableCell2>
                          {SummeryData ? SummeryData.comments : "null"}
                        </StyledTableCell2>
                        <StyledTableCell2>
                          {SummeryData
                            ? moment(SummeryData.chat_ended_at).format("L LT")
                            : ""}
                        </StyledTableCell2>
                        <StyledTableCell2 align="center">
                          {SummeryData ? SummeryData.channel : ""}
                        </StyledTableCell2>
                        <StyledTableCell2>
                          {SummeryData ? SummeryData.skillset : ""}
                        </StyledTableCell2>
                        <StyledTableCell2>
                          {SummeryData
                            ? `${SummeryData.agent
                              ? SummeryData.agent.username
                              : ""
                            } ${SummeryData2 ? SummeryData2.confUser : ""}`
                            : ""}
                        </StyledTableCell2>
                        <StyledTableCell2>
                          <IconButton
                            id="view_summery"
                            onClick={() => {
                              if (SummeryData.channel == "email") {
                                getSessionsDetailsForEmail(
                                  SummeryData ? SummeryData.chat_session_id : "",
                                  SummeryData ? SummeryData.ticketID : ""
                                );
                              } else {
                                showChatHistoryDialogBox(
                                  SummeryData ? SummeryData.chat_session_id : ""
                                );
                              }
                            }}
                          >
                            <Eye size={18} cursor={"pointer"} />
                          </IconButton>
                        </StyledTableCell2>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={SummeryCloseDialogBox} variant="outlined" color="error" size="small" sx={{ textTransform: "capitalize !important" }}>Close</Button>

          </DialogActions>
        </Dialog>
      )}
      {/* SUMMARY DIALOG END */}
      {/* INTERACTION HISTORY      */}
      {ChatHistoryOpenDialog && (
        <Dialog
          open={ChatHistoryOpenDialog}
          keepMounted
          onClose={ChatHistoryCloseDialog}
          aria-describedby="alert-dialog-slide-description"
          fullWidth maxWidth="lg"
        >
          <DialogTitle
            variant="subtitle2"
            sx={{ fontSize: "16px", fontWeight: 600, color: "#0b3363", boxShadow: "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px" }}
          >
            Interaction History
          </DialogTitle>
          <DialogContent>

            <DialogContentText id="alert-dialog-slide-description" className="mt-3">
              {(() => {
                switch (SummeryData ? SummeryData.channel : "") {
                  case "webchat":
                    return (
                      <Stack justifyContent={"center"} alignItems={"center"}>
                        <Input
                          aria-label="Demo input"
                          type="url"
                          value={searchMessage}
                          onChange={(e) => setsearchMessage(e.target.value)}
                          placeholder="Find Message...!"
                          startAdornment={
                            <InputAdornment>
                              <MagnifyingGlass size={22} weight="fill" />
                            </InputAdornment>
                          }
                        />
                        <div
                          className="chat-box-body"
                          style={{
                            backgroundColor: "transparent !important",
                            marginTop: "10px",
                          }}
                        >
                          <div className="chat-logs" style={{ height: "60vh" }}>
                            <Box

                              sx={{
                                flexGrow: 1,
                                backgroundColor: "#FFFF",
                                borderRadius: 0.9,
                                overflowY: "scroll",
                                scrollBehavior: "smooth",
                              }}
                              p={1}
                            >
                              <Stack spacing={2}>
                                {ChatHistory &&
                                  ChatHistory.filter((message) => {
                                    // const decryptedBytes = CryptoJS.AES.decrypt(message.message,"your-secret-key");
                                    // const decryptedData = decryptedBytes.toString(CryptoJS.enc.Utf8);
                                    return message.message
                                      .toLowerCase()
                                      .includes(searchMessage.toLowerCase());
                                  }).map((el, index) => {
                                    switch (el.msg_sent_type) {
                                      case "NOTIFICATIONS":
                                        return <Timeline el={el} key={index} />;
                                      case "IMAGE":
                                        return (
                                          <ImageMsg
                                            el={el}
                                            menu={false}
                                            key={index}
                                          />
                                        );
                                      case "APPLICATION":
                                        return (
                                          <DocMsg
                                            el={el}
                                            menu={false}
                                            key={index}
                                          />
                                        );
                                      case "AUDIO":
                                        return (
                                          <AudioMsg
                                            el={el}
                                            menu={false}
                                            key={index}
                                          />
                                        );
                                      case "VIDEO":
                                        return (
                                          <VideoMsg
                                            el={el}
                                            menu={false}
                                            key={index}
                                          />
                                        );
                                      default:
                                        return (
                                          <TextMsg
                                            el={el}
                                            menu={false}
                                            key={index}
                                          />
                                        );
                                    }
                                  })}
                              </Stack>
                            </Box>
                          </div>
                        </div>
                      </Stack>
                    );
                  case "email":
                    return (
                      <Box
                        className="CONTACT-LIST-AREA"
                        sx={{
                          flexGrow: 1,
                          backgroundColor: "#FFFF",
                          borderRadius: 0.9,
                          boxShadow: "0px 0px 2px rgba(0,0,0,0.25)",
                          overflowY: "scroll",
                          scrollBehavior: "smooth",
                        }}
                        p={1}
                      >
                        <Stack spacing={2}>
                          {Sessionvalforemail.length > 0
                            ? Sessionvalforemail.map((mail, index) => {
                              return (
                                <EmailBody
                                  mail={mail}
                                  index={index}
                                  handleChange={handleChange}
                                  expanded={expanded}
                                  preview={true}
                                />
                              );
                            })
                            : null}
                        </Stack>
                      </Box>
                    );
                  default:
                    return <>hello</>;
                }
              })()}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={ChatHistoryCloseDialog} variant="outlined" color="error" size="small" sx={{ textTransform: "capitalize !important" }}>Close</Button>

          </DialogActions>
        </Dialog>
      )}
      {/* INTERACTION HISTORY  end    */}
    </>
  );
};

export default SessionHistory;
